module.exports = __webpack_public_path__ + "img/thumbnail_JapaneseRaccoonDog_m_normal.644130cb.png";